export default __webpack_public_path__ + "static/media/MBRobostoOpen.e559b9b9.jpg";